module.exports = __webpack_public_path__ + "static/img/22.8f661ba8.png";